import type { Dict } from '../utils'

import { createContext } from '../utils'

const [StepperProvider, useStepperContext] = createContext<Dict>({ isOptional: true })

export { StepperProvider, useStepperContext }
